import './style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import * as dat from 'lil-gui';
import {Branch} from "./js/tree";


window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
const is_mobile = window.mobileAndTabletCheck();

const gui = is_mobile ? null : new dat.GUI({ width: 400 });
const canvas = document.querySelector('canvas.webgl');
const scene = new THREE.Scene();

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};
window.onresize = () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
};


const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100);
camera.position.set(2,0,2);
scene.add(camera);

const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

const renderer = new THREE.WebGLRenderer({canvas: canvas,antialias: true});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

let group;
const material = new THREE.MeshNormalMaterial();

const conf = {
    rotation_speed: 0.05,
    min_maintient_de_la_branche_mere: 0.1,
    max_maintient_de_la_branche_mere: 0.4,
    min_force_de_repartition: 0.6,
    max_force_de_repartition: 0.65,
    min_split_delay: 0.001,
    max_split_delay: 0.005,
    min_angle_de_separation: 0.5,
    max_angle_de_separation: 0.8,
    split_delay_offset: 0.3,
    radius: 0.0002,
    min_radius: 0.002,
    step: 0.28,
    force_de_depart: 300,
    detail: 1,
    tron_min_height: 0.5,
    main_keep: 0.2,
    re_generate: () => {
        scene.remove(group);
        generate();
    }
}



const speed_dom = document.getElementById("speed");
const generate = () => {
    const t1 = Date.now();
    group = new THREE.Group();
    group.position.y = -1.5
    scene.add(group);
    const branches = new Branch(conf, 0, 0,0, conf.force_de_depart, new THREE.Vector3(0, 1, 0), [new THREE.Vector3(0, 0, 0)], [conf.min_radius+conf.force_de_depart*conf.radius], conf.tron_min_height).grow();
    branches.forEach(branch => {
        if(branch.points.length < 2) return;
        const tube_geo = new THREE.TubeGeometry(new THREE.CatmullRomCurve3(branch.points), branch.forces.length-1, branch.forces, 6, false);
        const mesh = new THREE.Mesh(tube_geo, material);
        group.add(mesh);
    });
    const t2 = Date.now();
    speed_dom.innerHTML = `generated in ${t2-t1} ms`
}
generate();

if(!is_mobile){
    Object.keys(conf).forEach((key,i) => {
        if(i>6) return;
        gui.add(conf, key, 0, 1, 0.01);
    });
    gui.add(conf, "split_delay_offset", 0, 50, 0.1);
    gui.add(conf, "min_angle_de_separation", 0.01, 2, 0.01);
    gui.add(conf, "max_angle_de_separation", 0.01, 2, 0.01);
    gui.add(conf, "radius", 0.00001, 0.1, 0.00001);
    gui.add(conf, "min_radius", 0.00001, 0.1, 0.00001);
    gui.add(conf, "step", 0.001, 3, 0.0001);
    gui.add(conf, "force_de_depart", 1, 10000, 1);
    gui.add(conf, "detail", 2, 50, 1);
    gui.add(conf, "tron_min_height", 0, 2, 0.01);
    gui.add(conf, "main_keep", 0, 1, 0.01);
    gui.add(group.position, "y", -5, 5, 0.01);
    gui.add(conf, "re_generate");
    gui.close();
}



document.getElementById("regen").onclick = conf.re_generate;


const particlesGeometry = new THREE.BufferGeometry();
const count = 1000;

const positions = new Float32Array(count * 3);
const getRdmSgn = () => Math.random() < 0.5 ? -1 : 1;

for(let i = 0; i < count * 3; i++) {
    positions[i] = (Math.random() + 0.1) * 50 * getRdmSgn();
}
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

const particlesMaterial = new THREE.PointsMaterial({
    size: 0.16,
    sizeAttenuation: true
});

const particles = new THREE.Points(particlesGeometry, particlesMaterial);
scene.add(particles);


let tick_count = 0;
const clock = new THREE.Clock()
const tick = () => {
    tick_count++;
    const rot = clock.getElapsedTime() * conf.rotation_speed;
    group.rotation.y = rot;
    particles.rotation.y = rot;


    controls.update()
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}
tick()
const fps = document.getElementById("fps");
setInterval(()=>{fps.innerHTML = `fps : ${tick_count}`;tick_count=0}, 1000);
